// extracted by mini-css-extract-plugin
export default {"payment":"Payment_payment__Faprb","successContainer":"Payment_successContainer__Ivk9j"};